import { render, staticRenderFns } from "./BetsList.vue?vue&type=template&id=10526ed6&scoped=true&"
import script from "./BetsList.vue?vue&type=script&lang=js&"
export * from "./BetsList.vue?vue&type=script&lang=js&"
import style0 from "./BetsList.vue?vue&type=style&index=0&id=10526ed6&lang=scss&scoped=true&"
import style1 from "./BetsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10526ed6",
  null
  
)

export default component.exports